import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const PdfViewerModal = ({ 
  show, 
  onHide, 
  title = 'Vista Previa del Documento', 
  url, 
  size = 'xl'
}) => {
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const errorTimerRef = React.useRef(null);

  const handleCloseModal = () => {
    setPdfLoading(false);
    setLoadError(false);
    if (errorTimerRef.current) {
      clearTimeout(errorTimerRef.current);
      errorTimerRef.current = null;
    }
    onHide();
  };

  // Reset loading state when URL changes
  useEffect(() => {
    if (show && url) {
      setPdfLoading(true);
      setLoadError(false);
      // Clear any existing error timer
      if (errorTimerRef.current) {
        clearTimeout(errorTimerRef.current);
      }
      // Simular un pequeño delay para mostrar el loading
      const timer = setTimeout(() => setPdfLoading(false), 500);
      // Timeout para detectar si el PDF no carga después de 10 segundos
      errorTimerRef.current = setTimeout(() => {
        setLoadError(true);
        setPdfLoading(false);
        errorTimerRef.current = null;
      }, 10000);
      return () => {
        clearTimeout(timer);
        if (errorTimerRef.current) {
          clearTimeout(errorTimerRef.current);
          errorTimerRef.current = null;
        }
      };
    }
  }, [show, url]);

  // Prepare PDF URL - use simple URL without parameters that might trigger fullscreen
  const pdfUrl = url || '';

  return (
    <Modal 
      show={show} 
      onHide={handleCloseModal} 
      size={size}
      className="pdf-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {pdfLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <p className="mt-3">Cargando el documento...</p>
          </div>
        ) : loadError ? (
          <div className="text-center py-5">
            <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
            <p className="mt-3">No se pudo cargar el documento.</p>
            <p className="text-muted">Por favor, intenta descargarlo o abrirlo en una nueva pestaña.</p>
          </div>
        ) : (
          <div className="pdf-embed-container">
            <iframe
              src={pdfUrl}
              type="application/pdf"
              width="100%"
              height="600px"
              style={{ border: 'none' }}
              title={title}
              onLoad={() => {
                setLoadError(false);
                setPdfLoading(false);
                // Cancel error timer if iframe loads successfully
                if (errorTimerRef.current) {
                  clearTimeout(errorTimerRef.current);
                  errorTimerRef.current = null;
                }
              }}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-between align-items-center w-100">
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Cerrar
          </button>
          {url && (
            <a
              href={url}
              download
              className="btn btn-outline-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-download me-2"></i>
              Descargar PDF
            </a>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PdfViewerModal;
